import styles from './CommonAddMenu.module.css';
import { forwardRef, useState } from 'react';
import useContextMenu from '../../../../hooks/useContextMenu';
import { SchemeObjectTypes } from 'consts/scheme.consts';

const CommonAddMenu = forwardRef(
  (
    {
      actions,
      title = undefined,
      position = {
        top: 0 | undefined,
        right: 0 | undefined,
        bottom: 0 | undefined,
        left: 0 | undefined,
      },
      onSelect = undefined,
      open,
    },
    menuRef,
  ) => {
    const [submenuIndex, setSubmenuIndex] = useState(null);
    const [subSubmenuIndex, setSubSubmenuIndex] = useState(null);

    const [subMenuOpen, subMenuPosition, openSubMenu, closeSubMenu, subMenuRef] = useContextMenu({
      top: 0,
    });
    const [subSubMenuOpen, subSubMenuPosition, openSubSubMenu, closeSubSubMenu, subSubMenuRef] =
      useContextMenu({ top: 0 });

    const handleClickMenu = (item) => {
      if (onSelect) onSelect(item);
    };

    const handleMouseEnter = (index, event) => {
      setSubmenuIndex(index);
      openSubMenu(event);
      setSubSubmenuIndex(null);
      closeSubSubMenu();
    };

    const handleMouseLeave = () => {
      setSubmenuIndex(null);
      closeSubMenu();
      setSubSubmenuIndex(null);
      closeSubSubMenu();
    };

    const handleSubItemEnter = (subIndex, event) => {
      setSubSubmenuIndex(subIndex);
      openSubSubMenu(event);
    };

    const handleSubItemLeave = () => {
      setSubSubmenuIndex(null);
      closeSubSubMenu();
    };

    const renderSubSubItems = (subItem) => {
      const staticItems = [
        { title: 'Внешний', value: false },
        { title: 'Производный', value: true },
      ];

      return staticItems.map((item, i) => (
        <div
          key={i}
          className={styles.addingMenuItem}
          onClick={() => handleClickMenu({ ...subItem, derived: item.value })}
        >
          {item.title}
        </div>
      ));
    };

    const renderSubItems = (action) => {
      if (action?.items?.length === 0) {
        return <div className={styles.addingMenuItem}>Список пуст</div>;
      }

      return action.items.map((subItem, subIndex) => (
        <div
          key={subIndex}
          className={styles.addingMenuItem}
          onClick={() =>
            !subItem.items?.length &&
            subItem.type !== SchemeObjectTypes.typeSamples &&
            handleClickMenu(subItem)
          }
          onMouseEnter={(e) => handleSubItemEnter(subIndex, e)}
          onMouseLeave={handleSubItemLeave}
        >
          {subItem.title}
          {subSubmenuIndex === subIndex && subItem.type === SchemeObjectTypes.typeSamples && (
            <div
              ref={subSubMenuRef}
              className={styles.subMenuContainer}
              style={{
                top: subSubMenuPosition.top,
                bottom: subSubMenuPosition.bottom,
                display: subSubMenuOpen ? 'block' : 'none',
              }}
            >
              {renderSubSubItems(subItem)}
            </div>
          )}
        </div>
      ));
    };

    return (
      <div
        ref={menuRef}
        className={styles.addingMenuContainer}
        style={{
          top: position.top ?? 'unset',
          right: position.right ?? 'unset',
          bottom: position.bottom ?? 'unset',
          left: position.left ?? 'unset',
          display: open ? 'block' : 'none',
        }}
      >
        {title && <div className={styles.addingMenuTitle}>{title}</div>}
        {actions.map((item, index) => (
          <div
            key={index}
            className={styles.addingMenuItem}
            onClick={() => !item.items?.length && handleClickMenu(item)}
            onMouseEnter={(event) => handleMouseEnter(index, event)}
            onMouseLeave={handleMouseLeave}
          >
            {item.title}
            {item.items && submenuIndex === index && (
              <div
                ref={subMenuRef}
                className={styles.subMenuContainer}
                style={{
                  top: subMenuPosition.top,
                  bottom: subMenuPosition.bottom,
                  display: subMenuOpen ? 'block' : 'none',
                }}
              >
                {renderSubItems(item)}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  },
);

export default CommonAddMenu;
